<template>
  <footer class="icp-footer" :class="variant">
    <a
      class="icp-link"
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >桂ICP备2026013502号-1</a>
  </footer>
</template>

<script>
export default {
  name: 'IcpFooter',
  props: {
    /** login: 登录页浅色文字；layout: 内页底部 */
    variant: {
      type: String,
      default: 'layout'
    }
  }
}
</script>

<style scoped>
.icp-footer {
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
}
.icp-footer.login {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 2;
  color: rgba(255, 255, 255, 0.75);
}
.icp-footer.layout {
  padding: 10px 16px 14px;
  color: #909399;
  background: #f0f2f5;
  border-top: 1px solid #ebeef5;
}
.icp-link {
  color: inherit;
  text-decoration: none;
}
.icp-link:hover {
  text-decoration: underline;
  color: #409eff;
}
.icp-footer.login .icp-link:hover {
  color: #fff;
}
</style>
